import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const jiraSearchRoute: InvariantJiraRoute = {
	name: 'jira-search',
	path: '/jira/search',
	exact: true,
};
